import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import commaNumber from 'comma-number';
import { AiOutlineCheck } from 'react-icons/ai';

const Container = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  cursor: pointer;

  .checkbox {
    width: 13px;
    height: 13px;
    border: 1px solid #549a9a;
    border-radius: 2px;
    cursor: pointer;
    display: grid;
    place-items: center;
  }

  .checkbox_selected {
    width: 13px;
    height: 13px;
    border: 1px solid #549a9a;
    border-radius: 2px;
    cursor: pointer;
    display: grid;
    place-items: center;
    background: #549a9a;
  }

  .name {
    color: #003232;
    font-size: 12px;
    font-weight: 500;
  }
`;

const PriceFilter = ({ price, seller, handlePriceFilter, lowPrice }) => {
  return (
    <Container onClick={() => handlePriceFilter(price)}>
      <div style={{ display: 'inline-block' }}>
        <div
          className={
            Number(lowPrice) === price.low ? 'checkbox_selected' : 'checkbox'
          }
        >
          {' '}
          {Number(lowPrice) === price.low ? (
            <AiOutlineCheck color="#fff" size={12} />
          ) : null}{' '}
        </div>
      </div>
      <div className="name">{`${seller?.currency?.symbol}${commaNumber(
        price.low,
      )} - ${seller?.currency?.symbol}${commaNumber(price.high)}`}</div>
    </Container>
  );
};

export default PriceFilter;

PriceFilter.propTypes = {
  price: PropTypes.object.isRequired,
  seller: PropTypes.object.isRequired,
  handlePriceFilter: PropTypes.func.isRequired,
  lowPrice: PropTypes.string.isRequired,
};
